import React from 'react';

import {
  LeftRightExpandedIcon,
  LeftRightIcon,
  TreeDiagramIcon,
} from '@sharedCR/coreDesignSystem/icons';
import ButtonWithTooltip from 'app/shared/components/common/ButtonWithTooltip';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { IconOrientation, IconSize } from 'constants/coreDesignSystem';

import { DocumentTestIds } from '../../document.testIds';

const controlsWrapperStyles = { paddingTop: '10px' };
const controlStyles = {
  '&:not(:last-child)': { marginRight: '10px' },
  transform: 'rotate(90deg)',
};

const ThumbnailControlPanel = ({ disabledSplit = false, isPagesList, onSplit, onToggle }) => (
  <div
    className={clsx('flex items-center full-width')}
    data-testid={DocumentTestIds.DOCUMENT_PREVIEW_THUMBNAIL_CONTROL_PANEL}
    style={controlsWrapperStyles}
  >
    <div className="w-full flex justify-between p-8">
      <ButtonWithTooltip
        data-testid={DocumentTestIds.DOCUMENT_PREVIEW_TOGGLE_PAGES_BUTTON}
        icon={isPagesList ? LeftRightExpandedIcon : LeftRightIcon}
        iconOrientation={IconOrientation.VERTICAL}
        iconSize={IconSize[24]}
        size="small"
        sx={controlStyles}
        title={isPagesList ? 'Collapse' : 'Expand'}
        variant="outlined"
        onClick={onToggle}
      />

      {isPagesList && (
        <ButtonWithTooltip
          aria-label="Create new document with selected pages"
          data-testid={DocumentTestIds.DOCUMENT_PREVIEW_SPLIT_DOCUMENT_BUTTON}
          disabled={disabledSplit}
          icon={TreeDiagramIcon}
          iconSize={IconSize[24]}
          size="small"
          title="Split"
          variant="outlined"
          onClick={onSplit}
        />
      )}
    </div>
  </div>
);

ThumbnailControlPanel.propTypes = {
  isPagesList: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  disabledSplit: PropTypes.bool,
  onSplit: PropTypes.func,
};

export default ThumbnailControlPanel;
